export default "__VITE_ASSET__Cb_Yjzo6__"